import Loading from 'lib/loading';
import BlurImg from './stackblur/index';
import {convertFromCamelCase} from "../service/string.service";
require('./style.scss');

export default {
    _blurPanel: null,
    _blurViewerListener: {},
    _blurListener: {},
    _blurFlow: [
        {
            title: 'downloading original image',
            step: 1,
            className: 'loading-blur-block-step1',
        },
        {
            title: 'applying blur',
            step: 2,
            className: 'loading-blur-block-step2',
        },
        {
            title: 'uploading blurred image',
            step: 3,
            className: 'loading-blur-block-step3',
        },
        {
            title: 'processing blurred image',
            step: 4,
            className: 'loading-blur-block-step4',
        },
    ],


    addBlurListenerEvents(){
        this._blurListener = {
            blurProcessing: (step) => {
                try{
                    const blurProcess = this._blurFlow.filter((flow) => flow.step === step)[0];
                    this.loadingBlur.applyClass(blurProcess.className);

                }catch (e){
                    this.loadingBlur.hide();
                }
            },
            blurUpdatePanorama: (params) => {
                if(params) {
                    if(this.updateScenePanorama(params)){
                        this._fireEvent('floorplan.save', this.updateE3Floorplan());
                    }
                }
            },
            destroy: () => {
                if(this.loadingBlur) this.loadingBlur.destroy();
            },
            blurApply: () => {
                this.viewer.applyBlur();
            },
            removeAllBlurPolylines: () => {
                this.viewer.removeBlur();
                this._saveBlurplanServer();
            }
        }
        this._blurViewerListener = {
            saveBlurPolylines:  async () => {
                try{
                    this._saveBlurplanServer();
                    this._blurImg();
                }catch (e){
                    console.log(e)
                }

            },
            removeBlurPolylines: async () => {
                try{
                    this._saveBlurplanServer();
                    this._blurImg();
                }catch (e){
                    console.log(e)
                }

            }
        }

        for(var i in this._blurListener){
            this.on(convertFromCamelCase(i), this._blurListener[i]);
        }

        for(var i in this._blurViewerListener){
            this.viewer.on(convertFromCamelCase(i), this._blurViewerListener[i]);
        }
    },

    toggleBlurPlanEditMode(enable, isChanged=false){
        if (typeof enable === 'boolean') {
            this.blurEditMode = enable;
        }
        else {
            this.blurEditMode = !this.blurEditMode;
        }

        this.viewer.toggleBlurPlanEditorMode(this.blurEditMode);

        if(this.blurEditMode){
            this.addBlurListenerEvents();
            this.loadingBlur = new Loading(this.container, 'loading-blur');
            this.viewer.setBlurData(this.viewer._imageData);
            this.viewer.showRectangleCounter();
        }else{
            if(!isChanged) this.blurDestroy();
        }

        this._fireEvent('toogle-blur-floor-mode' , this.blurEditMode);
    },

    blurDestroy(){
        if(this.loadingBlur) this.loadingBlur.destroy();

        for(var i in this._blurListener){
            this.off(convertFromCamelCase(i), this._blurListener[i]);
        }

        for(var i in this._blurViewerListener){
            this.viewer.off(convertFromCamelCase(i), this._blurViewerListener[i]);
        }

        this.viewer.blurDestroy();

    },

    getBlurEditMode(){
      return this.blurEditMode;
    },

    _saveBlurplanServer(){
        this.setNeedUpdate3dTexture(true);

        this._fireEvent('blurplan.save', this.viewer.getBlurPolylines());
    },

    onBlurFinish(){
        this.loadingBlur.hide();
    },

    _blurGetPanoCoord(){
        const pano = this.config.image_data.url;
        const rectangles = this.viewer.getBlurCartCoord();
        if(!rectangles.length){
            this._fireEvent('blur-processing', 3)
            this._fireEvent('blur.img', pano);

            return ;
        }

        return {pano, rectangles};
    },

    async _blurImg(){
        this.loadingBlur.show();
        this.viewer.setWaitForStartDrawing(false);
        this._fireEvent('blur-processing', 1);
        const pano = this.config.image_data.url;
        const rectangles = this.viewer.getBlurCartCoord();
        if(!rectangles.length){
            this._fireEvent('blur-processing', 3)
            this._fireEvent('blur.img', pano);

            return ;
        }

        const blur = new BlurImg();
        blur.on('blur-processing', (step) => {
            this._fireEvent('blur-processing', step);
        })

        const image = await blur.createImage(pano);
        this._fireEvent('blur-processing', 2);

        let blob;
        try{
            blob = await blur.blurRectangles(image, rectangles);
        }catch (e){
            blur.destroy();
            this._modalService.alertModal(e);
            this.loadingBlur.destroy();

            return;
        }
        blur.destroy();

        this._fireEvent('blur-processing', 3)
        this._fireEvent('blur.img', blob);
    }
}
